export default "__VITE_ASSET__C7P0WYUx__"